<template>
  <div v-bem="'default'">
    <div v-bem.photo-wrapper="'default'"><img src="../assets/photo/putin-440.jpg" v-bem.photo="'default'"><div  v-bem.author="'default'" >Владимир Путин:</div></div>
    <div v-bem.text="'default'" v-html="text">
    </div>
    <div v-bem.description="'default'" v-html="description"></div>
  </div>
</template>
<script>
export default {
  name: 'cite-block',
  props: ['text', 'description']
}
</script>
<style>
@import '../style.css';
@use saladcss-bem;


@b cite-block {
  @e photo-wrapper {
    @m default {
      text-align:center;
    }
  }
  @m default {
    background-color: #183357;
    font-size:1.4rem;
    font-family: Open Sans,Arial,Helvetica,sans-serif;
    padding:10px;
    margin: 10px;
    color:white;
    }
  @e photo {
    @m default {
     width:150px;
     height:150px;
     border-radius:100px;
    }
  }
  @e description {
    @m default {
      font-size: 0.8rem;
      text-align:right;
    }
  }
}

@media (--ms){
  @b cite-block {
    @e photo {
      @m default {
        width:100px;
        height:100px;
        border-radius:100px;
      }
    }
    @e text {
      @m default {
      }
    }
    @e description {
      @m default {
        font-size: 0.8rem;
        text-align:right;
      }
    }
    @m default {
      width: 26%;
      margin-left: 1%;
      left:0;
      position: fixed;
      top: 19%;
      background-color: #a1abc6;
      z-index: 120;
      font-size:1rem;
      font-family: Open Sans,Arial,Helvetica,sans-serif;
      padding:10px;
      color: #0b212f;
      max-height:75%;
      overflow-y:auto;
    }
  }
}
@media(--ls){
  @b cite-block {
    @m default {
      font-size:1.2rem;
      top:22%;
    }
  }
}
@media(--xs){
  @b cite-block {
    @m default {
      font-size:1.6rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CiteBlock.vue